module.exports = __webpack_public_path__ + "f35dee1e80e5ec4123d1e138c841455e.png";